module.exports = __webpack_public_path__ + "img/img-2.67e3d5c8.png";